export async function translateText(text, target) {
  try {
    const response = await fetch("http://localhost:8081/api/translate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        text,
        target
      })
    });

    if (!response.ok) {
      throw new Error(`Translation API failed: ${response.status}`);
    }

    const data = await response.json();

    return {
      translatedText: data?.translatedText || text
    };
  } catch (error) {
    return {
      translatedText: "",
      error: error?.message || "Translation API unavailable"
    };
  }
}
